// @ts-strict-ignore
import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import { ProgressCheck } from "src/app/shared/models/progress-check.model";
import { SharedDirectivesModule } from "src/app/shared/shared-directives.module";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { DataService } from "src/app/shared/services/data.service";
import * as ProfileModel from "src/app/shared/models/profile.model";
import { GuidanceBoxComponent } from "src/app/modules/esim/shared/components/guidance-box/guidance-box.component";
import { ErrorMessageComponent } from "src/app/modules/esim/shared/components/error-message/error-message.component";

@Component({
  selector: C.EWIZ_HOME_PLMN_ACT_CONFIGURATION,
  templateUrl: "./home-plmn-act-configuration.component.html",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    SelectModule,
    TableModule,
    SharedDirectivesModule,
    GuidanceBoxComponent,
    ErrorMessageComponent
  ]
})
export class EWizHomePLMNACTConfigurationComponent extends EWizDynamicBaseClassComponent implements OnInit, ErrorCheck, ProgressCheck {
  constructor(private dataService: DataService) {
    super();

    this.accessTechnologyOptions = [
      { label: $localize`NG-RAN`, value: "1" },
      { label: $localize`E-UTRAN`, value: "2" },
      { label: $localize`E-UTRAN WB-S1`, value: "3" },
      { label: $localize`E-UTRAN NB-S1`, value: "4" },
      { label: $localize`UTRAN`, value: "5" },
      { label: $localize`GSM`, value: "6" },
      { label: $localize`EC-GSM IOT`, value: "7" },
      { label: $localize`GSM Compact`, value: "8" }
    ];
  }

  accessTechnologyOptions = [];

  ngOnInit() {
    this.errorCheck(this.profileValues, this.dataService);
  }

  convertToNull(value: string): string | null {
    return value === "" ? null : value;
  }

  errorCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    // Always reset error values to default state prior to executing check
    this.errorFound = false;
    this.errorMessage = "";

    if (values.homePLMNwithAcT) {
      for (const record of values.homePLMNwithAcT) {
        if (!dataService.isNullOrEmpty(record.mobileCountryCode) && record.mobileCountryCode.length < 3) {
          this.errorMessage = $localize`Mobile Country Codes must be 3 digits in length`;
          this.errorFound = true;
        }
        if (!dataService.isNullOrEmpty(record.mobileNetworkCode) && record.mobileNetworkCode.length < 2) {
          this.errorMessage = $localize`Mobile Network Codes must be 2 or 3 digits in length`;
          this.errorFound = true;
        }
      }
    }

    return this.errorFound;
  }

  progressCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    let oneCompleteRecord = false;

    if (values.homePLMNwithAcT) {
      for (const record of values.homePLMNwithAcT) {
        const hasCountryCode = !dataService.isNullOrEmpty(record.mobileCountryCode);
        const hasNetworkCode = !dataService.isNullOrEmpty(record.mobileNetworkCode);
        const hasAccessTechnology = !dataService.isNullOrEmpty(record.accessTechnology);

        if (hasCountryCode && (!hasNetworkCode || !hasAccessTechnology)) {
          return false;
        } else if (hasNetworkCode && (!hasCountryCode || !hasAccessTechnology)) {
          return false;
        } else if (hasAccessTechnology && (!hasCountryCode || !hasNetworkCode)) {
          return false;
        } else if (hasCountryCode && hasNetworkCode && hasAccessTechnology) {
          oneCompleteRecord = true;
        }
      }
    }

    if (!oneCompleteRecord) {
      return false;
    }

    return true;
  }
}
